import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/Redux/RootReducer';

const cookieState = (state: RootState) => state.modalWindows.cookieState;
const cookieData = createSelector(cookieState, (state) => state.cookieData);

export const cookieSelectors = {
  cookieData,
};
